/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleId
 */
export interface GoogleId {
    /**
     * 
     * @type {string}
     * @memberof GoogleId
     */
    googleId?: string;
}

/**
 * Check if a given object implements the GoogleId interface.
 */
export function instanceOfGoogleId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GoogleIdFromJSON(json: any): GoogleId {
    return GoogleIdFromJSONTyped(json, false);
}

export function GoogleIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'googleId': !exists(json, 'googleId') ? undefined : json['googleId'],
    };
}

export function GoogleIdToJSON(value?: GoogleId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'googleId': value.googleId,
    };
}

